import { Category } from "../types";
import { TwaHeader } from "./TwaHeader";
import { CustomPromptHero } from "./CustomPromptHero";
import { PhotoTile } from "./PhotoTile";

interface Props {
  categories: Category[];
  balance?: number;
  hasPhoto: boolean;
  prompt: string;
  onPromptChange: (v: string) => void;
  onSubmitCustom: (prompt: string) => void;
  onOpenCategory: (id: string) => void;
}

export function CategoryGrid({
  categories,
  balance,
  hasPhoto,
  prompt,
  onPromptChange,
  onSubmitCustom,
  onOpenCategory,
}: Props) {
  const dimmed = !hasPhoto && prompt.trim().length > 0;

  return (
    <div className="min-h-full" style={{ background: "var(--color-sk-bg)" }}>
      <TwaHeader balance={balance} />
      <div style={{ padding: "0 14px 24px" }}>
        {!hasPhoto && (
          <CustomPromptHero
            // Фото нет — значит текст рисует с нуля: и подсказки, и submit должны быть
            // про это. С вариантом "edit" здесь предлагались правки несуществующего фото.
            variant="create"
            value={prompt}
            onChange={onPromptChange}
            onSubmit={onSubmitCustom}
          />
        )}
        <div
          style={{
            color: "var(--color-sk-text-dim)",
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: 1,
            padding: "4px 4px 10px",
            textTransform: "uppercase",
            fontFamily: "var(--font-sk-mono)",
          }}
        >
          {hasPhoto ? "выбери шаблон для фото" : "или выбери раздел"}
        </div>
        <div className="flex flex-col" style={{ gap: 10 }}>
          {categories.map((c) => (
            <PhotoTile
              key={c.id}
              emoji={c.emoji}
              title={c.title}
              count={c.count}
              previewUrl={c.previewUrl}
              dimmed={dimmed}
              onClick={() => onOpenCategory(c.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
